export default "__VITE_ASSET__BFnugCYK__"